import { useTranslation } from 'react-i18next'

import type { SelectOption } from '@/components/Select/Select'
import { AsyncSelect } from '@/components/common/AsyncSelect'
import { teacherPaginatedQueryOptions } from '@/queries/useTeacherOptionsPaginated'
import type { FormFieldType } from '@/types/form-field-type'

const PreferredUsersSelect = (props: FormFieldType<SelectOption<string>[]>) => {
  const { t } = useTranslation('rooms')

  return (
    <AsyncSelect
      {...props}
      multiple
      placeholder={t('placeholder.select-user')}
      queryOptions={search => teacherPaginatedQueryOptions({ search })}
    />
  )
}

export default PreferredUsersSelect
